import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as ModalActions from '../actions/ModalActions';

@connect(
    state => ({
        isOpen: state.modal.isOpen,
        modalType: state.modal.type,
        props: state.modal.props
    }),
    {...ModalActions}
)
export default class ReduxModal extends Component {
    render() {
        if(! this.props.isOpen) {
            return <div className="modal fade"></div>
        }

        var props = Object.assign({}, this.props, this.props.props);

        return (
            <div className="modal-open">
                {React.createElement(this.props.modalType, props)}
                <div className="modal-backdrop fade in"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/ReduxModal.js